import { render, staticRenderFns } from "./produtos.vue?vue&type=template&id=d8e93984&scoped=true&"
import script from "./produtos.vue?vue&type=script&lang=js&"
export * from "./produtos.vue?vue&type=script&lang=js&"
import style0 from "./produtos.vue?vue&type=style&index=0&id=d8e93984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e93984",
  null
  
)

export default component.exports